<mat-menu #appMenu="matMenu" yPosition="above">
  @for (layer of enabledLayers(); track layer) {
    <div mat-menu-item>
      <mat-checkbox [value]="layer.visible.toString()" (change)="toggleLayer(layer.name)" [checked]="layer.visible" (click)="$event.stopPropagation()">
        {{layer.name | startCase}}
      </mat-checkbox>
    </div>
  }
</mat-menu>

<div class="map-control visibility-controls">
  <mat-card class="icon-panel">
    <button mat-icon-button matTooltip="Show/Hide Layers" [matTooltipShowDelay]="600" [matMenuTriggerFor]="appMenu">
      <mat-icon>layers</mat-icon>
    </button>
  </mat-card>
</div>
